import { h, FunctionComponent } from 'preact';
import { Image } from '../types';

const MainImage: FunctionComponent<MainImageProps> = ({
    images,
    imagesFull,
    onShowZoomView
}) => {
    if (images.length === 0) {
        return (
            <div class="js-product-image">
                <img src="/img/coming-soon.jpg" class="img-fluid" alt="" />
            </div>
        );
    }

    // devtodo ensure these are sorted in order of preference (avif > webp > jpeg)
    return (
        <div class="js-product-image text-left">
            <div class="btn-group">
                <button
                    type="button"
                    onClick={onShowZoomView}
                    class="btn-zoom"
                    aria-label="View this image full screen. This will open in a modal."
                >
                    <svg viewBox="0 0 24 24" height="24" width="24">
                        <path
                            d="m13.8753 9.49927v1.24983c0 .2578-.2109.4687-.4687.4687h-2.1873v2.1873c0 .2578-.2109.4687-.4687.4687h-1.24987c-.25778 0-.4687-.2109-.4687-.4687v-2.1873h-2.18729c-.25778 0-.4687-.2109-.4687-.4687v-1.24983c0-.25779.21092-.46871.4687-.46871h2.18729v-2.18728c0-.25779.21092-.46871.4687-.46871h1.24987c.2578 0 .4687.21092.4687.46871v2.18728h2.1873c.2578 0 .4687.21092.4687.46871zm7.8508 11.12003-1.1054 1.1053c-.3671.3672-.9608.3672-1.324 0l-3.8981-3.8941c-.1758-.1758-.2734-.414-.2734-.664v-.6367c-1.3788 1.0781-3.113 1.7186-4.9995 1.7186-4.48787 0-8.12424-3.6364-8.12424-8.1242 0-4.48784 3.63637-8.1242 8.12424-8.1242 4.4878 0 8.1242 3.63636 8.1242 8.1242 0 1.8865-.6406 3.6207-1.7186 4.9995h.6367c.2499 0 .4882.0977.664.2734l3.8941 3.8942c.3632.3671.3632.9608 0 1.328zm-6.2884-10.4951c0-2.93721-2.3748-5.31197-5.312-5.31197-2.93724 0-5.31201 2.37476-5.31201 5.31197 0 2.9372 2.37477 5.312 5.31201 5.312 2.9372 0 5.312-2.3748 5.312-5.312z"
                            fill="#2d2926"
                        />
                    </svg>
                </button>
                <a className="btn-download" href={imagesFull[0].url} target="_blank">
                    <span className="sr-only">Download this product image.</span>
                    <svg viewBox="0 0 24 24" height="24" width="24">
                        <path
                            d="m10.4375 2h3.125c.5195 0 .9375.41797.9375.9375v6.5625h3.4258c.6953 0 1.043.8398.5508 1.332l-5.9414 5.9453c-.293.293-.7735.293-1.0664 0l-5.94927-5.9453c-.49219-.4922-.14453-1.332.55078-1.332h3.42969v-6.5625c0-.51953.41797-.9375.9375-.9375zm11.5625 14.6875v4.375c0 .5195-.418.9375-.9375.9375h-18.125c-.51953 0-.9375-.418-.9375-.9375v-4.375c0-.5195.41797-.9375.9375-.9375h5.73047l1.91403 1.9141c.7852.7851 2.0508.7851 2.836 0l1.914-1.9141h5.7305c.5195 0 .9375.418.9375.9375zm-4.8438 3.4375c0-.4297-.3515-.7812-.7812-.7812s-.7812.3515-.7812.7812.3515.7812.7812.7812.7812-.3515.7812-.7812zm2.5 0c0-.4297-.3515-.7812-.7812-.7812s-.7812.3515-.7812.7812.3515.7812.7812.7812.7812-.3515.7812-.7812z"
                            fill="#2d2926"
                        />
                    </svg>
                </a>
            </div>
            <picture>
                {images.map(i => {
                    if (i.mime_type === 'image/jpeg') {
                        return <img src={i.url} alt="" />;
                    }

                    return <source srcset={i.url} type={i.mime_type} />;
                })}
            </picture>
        </div>
    );
};

interface MainImageProps {
    images: Image[];
    imagesFull: Image[];
    onShowZoomView: () => void;
}

export default MainImage;
